<template>
  <div class="ordersNew">
    <div v-if="$store.state.isMobile">
      <tabs :tabs="$route.query.orderType == 1 ? ['团队订单', '未提交订单'] : ['个人订单']"></tabs>
      <personalCard type="line" v-for="item in orders" :key="item.orderId" v-show="orders.length">
        <div slot="left" :class="`leftName orderStatus_${item.orderStatus}`">{{$store.state.ticketDetail.ticketName}}</div>
        <div slot="right" :class="`rightContent orderStatus_${item.orderStatus}`">
          <div class="detail">
            <span class="title">预约时间</span>
            <span class="name">{{item.bookingDate}}（{{item.timeRange}}）</span>
          </div>
          <div class="detail" v-if="item.peopleCount">
            <span class="title">参观人数</span>
            <span class="name">{{item.peopleCount}}人</span>
          </div>
          <div class="detail" v-if="item.orgName">
            <span class="title">团队名称</span>
            <span class="name">{{item.orgName}}</span>
          </div>
          <div class="buttonsWarp">
            <div class="buttonCancel" @click="showOrderDetail('cancel', item.orderId)" v-if="item.orderStatus == 1 && !($route.query.orderType == 1 && activeTabIndex == 1) && item.auditState != 2">取消</div>
            <!-- <div class="buttonCancel" @click="delOrderById(item.orderId)" v-if="!(item.orderStatus == 3 && item.orderType == 2) && activeTabIndex == 1">删除</div> -->
            <div class="buttonConfirm" @click="showOrderDetail('look', item.orderId, item.orderStatus, item)">查看</div>
          </div>
          <!-- <div v-if="item.orderType == 1" class="tuan"></div> -->
        </div>
        <div slot="status">
          <!-- 待提交的 审核的 -->
          <div class="orderStatus">{{$route.query.orderType == 1 && activeTabIndex == 1 && item.orderStatus == 1 ? '待提交' : ($route.query.orderType == 1 && item.auditState != 4 && item.orderStatus == 1 ? auditStates[item.auditState] : orderStatus[item.orderStatus])}}</div>
        </div>
      </personalCard>
      <div class="noData" v-if="!orders.length">暂无数据</div>
    </div>
    <div v-else>
      <topBanner></topBanner>
      <div class="pcContent">
        <div class="buttonNormal backPersonCenter" @click="backPersonCenter">返回个人中心</div>
        <!-- <pcTabs2 :reservationType="1"></pcTabs2> -->
        <div class="pcItemCard">
          <pcTabs :tabs="$route.query.orderType == 1 ? ['团队订单', '未提交订单'] : ['个人订单']"></pcTabs>
          <div class="personals">
            <personalCard type="line" v-for="item in orders" :key="item.orderId" v-show="orders.length">
              <div slot="left" :class="`leftName orderStatus_${item.orderStatus}`">{{$store.state.ticketDetail.ticketName}}</div>
              <div slot="right" :class="`rightContent orderStatus_${item.orderStatus}`">
                <div class="detail">
                  <span class="title">预约时间</span>
                  <span class="name">{{item.bookingDate}}（{{item.timeRange}}）</span>
                </div>
                <div class="detail" v-if="item.peopleCount">
                  <span class="title">参观人数</span>
                  <span class="name">{{item.peopleCount}}人</span>
                </div>
                <div class="detail" v-if="item.orgName">
                  <span class="title">团队名称</span>
                  <span class="name">{{item.orgName}}</span>
                </div>
                <div class="buttonsWarp">
                  <div class="buttonCancel" @click="showOrderDetail('cancel', item.orderId)" v-if="item.orderStatus == 1 && !($route.query.orderType == 1 && activeTabIndex == 1) && item.auditState != 2">取消</div>
                  <!-- <div class="buttonCancel" @click="delOrderById(item.orderId)" v-if="!(item.orderStatus == 3 && item.orderType == 2) && activeTabIndex == 1">删除</div> -->
                  <div class="buttonConfirm" @click="showOrderDetail('look', item.orderId, item.orderStatus, item)">查看</div>
                </div>
                <!-- <div v-if="item.orderType == 1" class="tuan"></div> -->
              </div>
              <div slot="status">
                <div class="orderStatus">{{$route.query.orderType == 1 && activeTabIndex == 1 && item.orderStatus == 1 ? '待提交' : ($route.query.orderType == 1 && item.auditState != 4 && item.orderStatus == 1 ? auditStates[item.auditState] : orderStatus[item.orderStatus])}}</div>
              </div>
            </personalCard>
            <div class="noData" v-if="!orders.length">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
    <div :class="$store.state.isMobile ? '' : 'pcContent'"  v-if="showPop">
      <pop>
        <slot>
          <div class="confirmText">您确定要删除吗？</div>
          <div class="buttonsWarp">
            <div class="buttonCancel" @click="cancel">取消</div>
            <div class="buttonConfirm" @click="confirm">确定</div>
          </div>
        </slot>
      </pop>
    </div>
  </div>
</template>

<script>
import tabs from '../../components/common/tabs.vue'
import pcTabs from '../../components/common/pcTabs.vue'
import personalCard from '../../components/common/personalCard.vue'
import topBanner from '../../components/common/topBanner'
// import pcTabs2 from '../../components/ticket/pcTabs'
import pop from '../../components/common/pop'
export default {
  data() {
    return {
      orders: [],
      activeTabIndex: 0,
      showPop: false,
      orderStatus: ['', '待使用', '已使用', '已取消', '已过期'],
      auditStates: ['未审核', '通过审核', '未通过审核', '无需审核']
    };
  },

  components: {tabs, personalCard, pcTabs, topBanner, pop},

  methods: {
    activeTab(index) {
      this.activeTabIndex = index
      this.getOrders(index)
    },

    // 返回个人中心
    backPersonCenter() {
      this.$router.push({name: 'personalCenter', query: this.$route.query})
    },

    cancel() {
      this.showPop = false
    },

    confirm() {
      this.showPop = false
    },

    // 删除订单、仅限未提交订单
    delOrderById(id) {
      this.$ajax.delete(`/api/ticket/front/order/temp-order?id=${id}`).then((res) => {
        this.$message.success('删除成功')
        this.getOrders(1)
      })
    },

    showOrderDetail(type, id, status, item) {
      let query = this.$route.query
      query.orderId = id
      if (type == 'look' && this.activeTabIndex == 1 && status == 1) {
        query.belongId = item.peopleId
        return this.$router.push({name: 'groupDetail', query})
      }
      if (type == 'look' && status == 1) return this.$router.push({path: '/ticket/re_success', query})
      query.type = type
      this.$route.query.id ? query.id = this.$route.query.id : ''
      this.$router.push({path: '/ticket/orderDetail', query})
    },

    delOrder(item) {
      this.showPop = true
    },

    getOrders(status) {
      let url = (status && this.$route.query.orderType == 1) ? `/api/ticket/front/order/my-temp-order` : `/api/ticket/front/order/my-order?museumCode=${this.$route.query.museumCode}&orderType=${this.$route.query.orderType || 2}${this.$route.query.id ? `&ticketId=${this.$route.query.id}` : ''}`
      this.$ajax(url).then((res) => {
        this.orders = []
        res.data.map((item) => {
          item.bookingDate = item.bookingDate.replaceAll('-', '/').split(' ')[0]
          item.timeRange = item.timeRange.replace(':00-', '-').substring(0,11)
          let orderItemIndex = this.orders.findIndex((o)=>{return item.orderId == o.orderId})
          if (!(status && this.$route.query.orderType == 1 && item.orderStatus == 4)) {
            if (orderItemIndex == -1) { //没有订单
              this.orders.push(item)
            } else if(item.orderStatus == 1 && this.orders[orderItemIndex].orderStatus != 1) {
              this.orders.splice(orderItemIndex, 1, item)
            }
          }
        })
      })
    }
  },

  created() {
    this.getOrders(0)
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.ordersNew{
  .detail{
    .title{
      margin-right: 0.3rem;
    }
  }
  .confirmText{
    margin: 0.5rem 0;
    font-size: 0.6rem;
    font-weight: 500;
  }
  .buttonsWarp{
    justify-content: flex-end;
    div{
      width: 2.5rem;
      margin-left: 0.5rem;
      margin-right: 0.4rem;
    }
  }
  .pcItemCard{
    margin-top: 40px;
    .personals{
      display: flex;
    }
  }
  .noData{
    margin-top: 1rem;
    text-align: center;
    width: 100vw;
    font-size: 0.5rem;
  }
  .pcContent{
    .noData{
      font-size: 30px;
    }
    .backPersonCenter{
      width: 150px;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      text-align: center;
      margin: 0;
      margin-left: 1050px;
    }
    .pcItemCard{
      margin-top: 30px !important;
    }
  }
}
</style>
<style type="text/css" lang="scss">
.ordersNew{
  .orderStatus_4{
    opacity: 0.6;
  }
  .personalCard{
    .orderStatus{
      position: absolute;
      top: 0.2rem;
      right: 0.2rem;
      font-size: 0.4rem;
    }
    .right{
      margin-top: 0.6rem;
    }
  }
  .pcItemCard{
    .personalCard{
      margin: 30px 0;
      .leftLine{
        padding: 0;
        width: 76px;
        min-height: 150px;
        max-height: 300px;
        max-width: 100px;
        margin: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .leftName{
        font-size: 20px !important;
        max-width: unset !important;
        height: auto !important;
        line-height: 26px !important;
      }
      .right{
        width: 370px;
        margin-left: 0;
        margin-top: 30px;
        .rightContent{
           width: 360px !important;
        }
      }
      .orderStatus{
        font-size: 24px;
        top: 15px;
      }
      .buttonsWarp{
        margin-top: 20px;
      }
    }
    .personalCard:nth-child(2n-1){
      margin-right: 4%;
    }
  }
}
</style>

